import i18n from '@/plugins/i18n';

export function useNumberFormatter() {
    const n = i18n.global.n;
    const locale = i18n.global.locale;

    const formatNumber = (value: number | string | null | undefined, key: string = 'money') => {
        if (value === null || value === undefined) return '';
        const num = Number(value);
        if (Number.isNaN(num)) return '';

        return n(num, key, locale.value);
    };

    return { formatNumber };
}
